import React from 'react';
import ReactDOM from 'react-dom';
import './css/style.css';
import './css/responsive.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
